import { IHttpApi } from '@cian/http-api';
import { IFilterNewBuildingsRequest } from '../../types/newBuldings/filters';
import { INewbuildingsData } from '../../types/newBuldings';
import {
  fetchGetNewbuildingsForDeveloperCard,
  IGetNewbuildingsForDeveloperCardResponse,
  IGetNewbuildingsForDeveloperCardResponse200,
} from '../../repositories/newbuilding-search/v1/get-newbuildings-for-developer-card';
import {
  newbuildingMapper,
  mapNewbuildingResponse,
  mapNewbuildingResponseError,
  newbuildingCountsMapper,
} from '../../mappers';
import { assertNotFoundError } from './assert/assertNotFoundError';

export async function getNewBuildings(props: {
  httpApi: IHttpApi;
  parameters: IFilterNewBuildingsRequest;
  subdomain: string;
}): Promise<INewbuildingsData> {
  const response = await fetchGetNewbuildingsForDeveloperCard({
    httpApi: props.httpApi,
    parameters: props.parameters,
    mappers: {
      200: mapNewbuildingResponse,
      400: mapNewbuildingResponseError,
    },
  });

  assertNotFoundError(response);

  const data = (response as IGetNewbuildingsForDeveloperCardResponse200)
    .response as IGetNewbuildingsForDeveloperCardResponse;

  return {
    jsonQuery: data.jsonQuery,
    newbuildingCounts: newbuildingCountsMapper(data.newbuildingCounts),
    newbuildings: data.newbuildings.map(item => newbuildingMapper(item)),
  };
}
